import script from "./LogoutButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoutButton.vue?vue&type=script&lang=ts&setup=true"

import "./LogoutButton.vue?vue&type=style&index=0&id=ab65a4d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab65a4d4"]])

export default __exports__